<div class="container">
  <div class="row justify-content-center mt-5">
    <div class="col-md-6">
      <div class="login-form">
        <div class="text-center mb-4">
          <h3 class="font-weight-bold text-primary">Welcome<span style="color: blue;"> KIKCAD 2D</span></h3>
          <p class="text-muted font-weight-bold">
            Embrace the creative possibilities as you dive into design estimation. Your journey is unique. Explore freely and enjoy the process of bringing your designs to life. Happy creating!
          </p>
        </div>
        
        
        <form class="form" [formGroup]="loginForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div style="width: 256px; align-items: center; margin: 0 auto;
        text-align: center;">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="material-icons">email</i></span>
              </div>
              <input type="email" id="email" class="form-control" placeholder="{{ 'AUTH.INPUT.EMAIL' | translate }}" formControlName="email" autocomplete="off" />
            </div>
            <mat-error *ngIf="isControlHasError('email', 'required')">
              <strong>{{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="isControlHasError('email', 'email')">
              <strong>{{ "AUTH.VALIDATION.INVALID_FIELD" | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="isControlHasError('email', 'minlength')">
              <strong>{{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</strong>
            </mat-error>
            <mat-error *ngIf="isControlHasError('email', 'maxlength')">
              <strong>{{ "AUTH.VALIDATION.MAX_LENGTH_FIELD" | translate }} 320</strong>
            </mat-error>
          </div>

          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="material-icons">lock</i></span>
              </div>
              <input type="password" id="password" class="form-control" placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}" formControlName="password" autocomplete="off" />
            </div>
            <mat-error *ngIf="isControlHasError('password', 'required')">
              <strong>{{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="isControlHasError('password', 'minlength')">
              <strong>{{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</strong>
            </mat-error>
            <mat-error *ngIf="isControlHasError('password', 'maxlength')">
              <strong>{{ "AUTH.VALIDATION.MAX_LENGTH_FIELD" | translate }} 100</strong>
            </mat-error>
          </div>
          <div class="text-center mt-3">
            <a href="javascript:;" routerLink="/auth/forgot-password" class="text-primary text-hover-primary">{{ "AUTH.GENERAL.FORGOT_BUTTON" | translate }}</a>
          </div>
          <div class="form-group d-flex justify-content-between align-items-center mt-4">
            <button id="kt_login_signin_submit" (click)="submit()" [ngClass]="{
              'spinner spinner-right spinner-md spinner-light': loading
            }" class="btn btn-primary font-weight-bold px-4 py-2">{{ "AUTH.LOGIN.BUTTON" | translate }}</button>
            <button href="javascript:;" routerLink="/auth/register" class="btn btn-primary font-weight-bold px-4 py-2">{{ "AUTH.GENERAL.SIGNUP_BUTTON" | translate }}</button>
          </div>
        </div>
          <p>
            <a href="https://kikblox.com" target="_blank">Kikblox</a> |
            <a href="https://lk.linkedin.com/company/kikblox" target="_blank">LinkedIn</a> |
            <a href="https://www.youtube.com/@kikblox" target="_blank">YouTube</a>
          </p>
          
        
          <div class="text-muted font-weight-bold mt-4">
            <p style="font-size: 8.5px;">
            By accessing this KIKCAD 2D software, you acknowledge that its usage is at your own discretion. KIK (Pvt) LTD disclaims any liability for errors, losses, or damages resulting from its use.
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


